import apiPath from '../../../config/api';

const LossesPath = {
    title: "Toko Material - Modul Kerugian",
    basePath: "/material/kerugian",
    newPath: "/material/kerugian/baru",
    detailPath: "/material/kerugian/opsi/:id",
    base: apiPath.retailLosses,
    gnsFind: apiPath.masterGnsFind,
    gnsNmFilter: apiPath.masterGnsNmFilter,
    gnsCodeFilter: apiPath.masterGnsCodeFilter,
    gns: apiPath.masterGns,
    unitFilter: apiPath.masterUnitFilter,
    unit: apiPath.masterUnit
}

export default LossesPath;
